import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayTimeManagementSkillsRatingSelectedPayload {
  shiftId: string;
  rating: number;
}

/**
 * Fires when an office adjusts the time management star rating on the
 * end-of-day review page.
 * Event: dental_portal:end_of_day:time_management_skills_rating_selected
 */
export function fireEndOfDayTimeManagementSkillsRatingSelected(
  payload: IEndOfDayTimeManagementSkillsRatingSelectedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:end_of_day:time_management_skills_rating_selected',
    {
      shift_id: payload.shiftId,
      rating: payload.rating,
    },
  );
}
